module.exports = require('./lib/index').default;


//////////////////
// WEBPACK FOOTER
// ./~/axios-retry/index.js
// module id = 198
// module chunks = 17